// OPERATORS
export const OPERATOR_LIST = 'OPERATOR_LIST'
export const OPERATOR_SUBMIT_FORM = 'OPERATOR_SUBMIT_FORM'
export const OPERATOR_GET_INFO = 'OPERATOR_GET_INFO'
export const OPERATOR_UPDATE_INFO = 'OPERATOR_UPDATE_INFO'
export const OPERATOR_DELETE = 'OPERATOR_DELETE'
